/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */

export const SEARCH_RESULTS_ASYNC_QUERY_PERSISTED_ID = '10178ebf68f377bad243d991ae67b9a2bffb46ccf7e81f77e2bf633e65b7d35e';
export const SEARCH_RESULTS_ASYNC_QUERY_OPERATION_NAME = 'searchResultsAsyncQuery';
